const baseURL = "/v1/PerfilDaTurma";

const service = {
  methods: {
    $buscarComponenteCurricular() {
      return this.$api().get(`${baseURL}/Componente-Curricular`);
    },
    $buscarNivelEnsino() {
      return this.$api().get(`${baseURL}/Nivel-Ensino`);
    },
    $buscarPerfisTurmas(funcionalidade, params) {
      return this.$api().get(`${baseURL}/${funcionalidade}`, params);
    },
    $visualizarPerfilTurma(funcionalidade, id) {
      return this.$api().get(`${baseURL}/${funcionalidade}/${id}`);
    },
    $cadastrarPerfilTurma(funcionalidade, body) {
      return this.$api().post(`${baseURL}/${funcionalidade}`, body);
    },
    $editarPerfilTurma(funcionalidade, id, body) {
      return this.$api().put(`${baseURL}/${funcionalidade}/${id}`, body);
    },
    $inativarAtivarPerfilTurma(funcionalidade, id) {
      return this.$api().patch(`${baseURL}/${funcionalidade}/${id}/AlterarStatus`);
    },
  },
};

export default service;
